import { Dimensions, Platform, StatusBar } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
const X_WIDTH = 375;
const X_HEIGHT = 812;
const XSMAX_WIDTH = 414;
const XSMAX_HEIGHT = 896;
const { height: W_HEIGHT, width: W_WIDTH } = Dimensions.get('window');
let isIPhoneXMax_v = false;
let isIPhoneWithMonobrow_v = false;
if (Platform.OS === 'ios' && !Platform.isPad && !Platform.isTVOS) {
    if (W_WIDTH === X_WIDTH && W_HEIGHT === X_HEIGHT) {
        isIPhoneWithMonobrow_v = true;
    }
    if (W_WIDTH === XSMAX_WIDTH && W_HEIGHT === XSMAX_HEIGHT) {
        isIPhoneWithMonobrow_v = true;
        isIPhoneXMax_v = true;
    }
}
export const isIPhoneX = () => DeviceInfo.isIphoneX;
export const isIPhoneXMax = () => isIPhoneXMax_v;
export const isIPhoneWithMonobrow = () => isIPhoneWithMonobrow_v;
export function getStatusBarHeightV(skipAndroid) {
    return Platform.select({
        ios: isIPhoneWithMonobrow_v ? 44 : 20,
        android: skipAndroid ? 0 : StatusBar.currentHeight,
        default: 0
    });
}
export function getStatusBarHeight() {
    var _a;
    const notchHeight = ((_a = DeviceInfo === null || DeviceInfo === void 0 ? void 0 : DeviceInfo.immersiveInfo) === null || _a === void 0 ? void 0 : _a.immersiveOffset) || 0;
    return DeviceInfo.isAndroid ? notchHeight : DeviceInfo.isIphoneX ? 44 : 20;
}
export function getBottomBarHeight() {
    return Platform.select({
        ios: isIPhoneWithMonobrow_v ? 34 : 0,
        android: 0,
        default: 0
    });
}
